import GameUtils from '../gameutils'
import { createMessage } from '../createMessage'
import { Status, ErrorTexts } from '../../lib/constants'
import { logger } from "../../helpers/logger"

export function login(that, status) {
  const session = GameUtils.getParameterByName('session')
  if (typeof session === 'string') {
    const loginMsg = createMessage('auth', session)
    that.sendMessage(loginMsg)
  } else {
    // TODO : not logged in error page or notification
    console.error('not logged in ' + status)
  }
}

export function statusHelper(status, that, handleErrorText) {
  // logger.log('%cstatus =', 'color:brown', status)
  switch (status) {
    case Status.CONNECTED:
      logger.log('%cconnected ', 'color:green')
      login(that, status)
      break
    case Status.DISCONNECTED:
      handleErrorText(ErrorTexts.CONNECTION_LOST)
      console.error('%cdisconnected ', 'color:brown')
      that.onReceiveMessage({
        data: JSON.stringify({ service: 'disconnect' }),
      })
      break

    default:
      break
  }
}
